/**
 * alert-list.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";
import { Alert, AlertService } from "./alert.service";
import { Router } from "@angular/router";

/**
 * The {@link AlertListComponent} is a visual container for the {@link Alert}s
 * managed by the {@link AlertService}, and displays them in distinct, themed
 * boxes overlayed on the application root.
 */
@Component({
  selector: "alert-list",
  template: `
  <div *ngFor="let alert of alertService.alerts">
    <!-- ALERT alert -->
    <div
      *ngIf="!alert.suppressed && alert.type === 'error'"
      (click)="alertService.cancelTimeout(alert)"
      class="alert fade alert-dismissable alert-danger"
      [class.in]="alert.show"
      role="alert">
      <button
        type="button"
        class="close"
        aria-label="close"
        (click)="alertService.remove(alert)">
        <span aria-hidden="true">x</span>
      </button>
      <span
        class="glyphicon glyphicon-exclamation-sign"
        aria-hidden="true">
      </span>
      <span class="sr-only">
        Error:
      </span>
      <span class="text" [innerHtml]="alert.message"></span>
      <button
        *ngIf="alert.action"
        class="btn btn-xs btn-danger"
        (click)="act(alert)">
        {{alert.actionLabel || "OK"}}
      </button>
    </div>

    <!-- WARNING alert -->
    <div
      *ngIf="!alert.suppressed && alert.type === 'warning'"
      (click)="alertService.cancelTimeout(alert)"
      class="alert fade alert-dismissable alert-warning"
      [class.in]="alert.show"
      role="alert">
      <button
        type="button"
        class="close"
        aria-label="close"
        (click)="alertService.remove(alert)">
        <span aria-hidden="true">x</span>
      </button>
      <span
        class="glyphicon glyphicon-flag"
        aria-hidden="true">
      </span>
      <span class="sr-only">
        Warning:
      </span>
      <span class="text" [innerHtml]="alert.message"></span>
      <button
        *ngIf="alert.action"
        class="btn btn-xs btn-warning"
        (click)="act(alert)">
        {{alert.actionLabel || "OK"}}
      </button>
    </div>

    <!-- NOTIFICATION alert / USER alert -->
    <div
      *ngIf="!alert.suppressed && (alert.type === 'notification' || alert.type === 'user')"
      (click)="alertService.cancelTimeout(alert)"
      class="alert fade alert-dismissable alert-info"
      [class.in]="alert.show"
      role="alert">
      <button
        type="button"
        class="close"
        aria-label="close"
        (click)="alertService.remove(alert)">
        <span aria-hidden="true">x</span>
      </button>
      <span
        class="glyphicon"
        [class.glyphicon-info-sign]="alert.type === 'notification'"
        [class.glyphicon-user]="alert.type === 'user'"
        aria-hidden="true">
      </span>
      <span class="sr-only">
        Information:
      </span>
      <span class="text" [innerHtml]="alert.message"></span>
      <button
        *ngIf="alert.action"
        class="btn btn-xs btn-info"
        (click)="act(alert)">
        {{alert.actionLabel || "OK"}}
      </button>
    </div>

    <!-- SUCCESS alert -->
    <div
      *ngIf="!alert.suppressed && alert.type === 'success'"
      (click)="alertService.cancelTimeout(alert)"
      class="alert fade alert-dismissable alert-success"
      [class.in]="alert.show"
      role="alert">
      <button
        type="button"
        class="close"
        aria-label="close"
        (click)="alertService.remove(alert)">
        <span aria-hidden="true">x</span>
      </button>
      <span
        class="glyphicon glyphicon-ok"
        aria-hidden="true">
      </span>
      <span class="sr-only">
        Success:
      </span>
      <span class="text" [innerHtml]="alert.message"></span>
      <button
        *ngIf="alert.action"
        class="btn btn-xs btn-success"
        (click)="act(alert)">
        {{alert.actionLabel || "OK"}}
      </button>
    </div>


    <!-- COUNTDOWN alert -->
    <div
      *ngIf="!alert.suppressed && alert.type === 'countdown'"
      class="alert fade alert-warning"
      [class.in]="alert.show"
      role="alert">
      <span
        class="glyphicon glyphicon-time"
        aria-hidden="true">
      </span>
      <span class="sr-only">
        Notification:
      </span>
      <strong>
        <countdown [seconds]="alert.timeout / 1000"></countdown>
      </strong>
      <span class="text" [innerHtml]="alert.message"></span>
      <button
        *ngIf="alert.action"
        class="btn btn-xs btn-warning"
        (click)="act(alert)">
        {{alert.actionLabel || "OK"}}
      </button>
    </div>
  </div>
  `,
  styles: [
    `:host {pointer-events: none;}`,
    `.alert {
      display: inline-block;
      margin-bottom: 10px;
      pointer-events: all;
    }
    .alert .text {
      margin-right: 10px;
    }
    countdown {
      padding-right: 10px;
    }`
  ]
})
export class AlertListComponent
{
  /**
   * Construct a new {@link NavigationBarComponent}.
   *
   */
  public constructor (public alertService : AlertService, public router: Router)
  {
    // Nothing
  }

  /**
   * [act description]
   * @param  {Alert}  alert [description]
   * @return {[type]}
   */
  public act (alert : Alert) : void
  {
    if (!alert.action)
    {
      throw new Error("Alert has no action defined!");
    }
    alert.action(this.router);
    this.alertService.remove(alert);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/alert-list.component.ts